import { idtype, heroImg } from "querypieces";

export default `
...on pageBuilder_hero_BlockType {
	${idtype}
	altText
	themePicker
	${heroImg}
}
`